import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { Link, number } from "react-admin";
import CustomArrowCircleLeftSharpIcon from "../../unit/CustomArrowCircleLeftSharpIcon";

const LoanStageStatus = ({ ...props }) => {
  const {
    loanStatus,
    curStatus,
    creditBalance,
    modify_num,
    maturityDate,
    transferFatalErrorNumber,
    transferFailedNumber,
    insufficientBalanceCheckNumber,
    smartach,
  } = props;

  const getRemainingTermFilter = (loanMaturityDate: any) => {
    if (!loanMaturityDate) {
      return "<12 Months";
    }

    const maturity = new Date(loanMaturityDate);

    if (Number.isNaN(maturity.getTime())) {
      return "<12 Months";
    }

    const now = new Date();
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const remainingDays = Math.floor(
      (maturity.getTime() - now.getTime()) / millisecondsPerDay
    );

    if (remainingDays >= 1825) {
      return ">60 Months";
    }
    if (remainingDays >= 1460) {
      return "48-60 Months";
    }
    if (remainingDays >= 1095) {
      return "36-48 Months";
    }
    if (remainingDays >= 730) {
      return "24-36 Months";
    }
    if (remainingDays >= 365) {
      return "12-24 Months";
    }

    return "<12 Months";
  };

  const remainingTermFilter = getRemainingTermFilter(maturityDate);
  const defaultActiveBackLink = `/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"${remainingTermFilter}"}`;
  let loanBgColor = "";
  let loanStage = "";
  let loanStageStatus = "";
  let backLink =
    '/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}';
  loanStage = "";
  if (loanStatus == "Voided") {
    backLink = '/loans?filter={"status":"Voided"}';
    loanStage = "Voided Last 12 Months";
    loanBgColor = "#00000014";
  } else if (loanStatus == "Charged-Off") {
    backLink = '/loans?filter={"status":"Charged-Off"}';
    loanStage = "Charged-Off Last 12 Months";
    loanBgColor = "#00000014";
  } else if (loanStatus == "Paid-Off") {
    if (Number(creditBalance) < 0) {
      backLink =
        '/loans?filter={"status":"Paid-Off","curStatus":"creditBalance"}';
      loanStage = "Paid-Off with Credit Balance";
      loanBgColor = "#d32f2f";
    } else {
      backLink = '/loans?filter={"status":"Paid-Off"}';
      loanStage = "Paid-Off Last 12 Months";
      loanBgColor = "#00000014";
    }
  } else {
    // if (localStorage.getItem("backUrl-" + props.appId + "-" + props.loannum)) {
    //   backLink = localStorage.getItem(
    //     "backUrl-" + props.appId + "-" + props.loannum
    //   ) as string;
    // } else {

    console.log("modify_num", curStatus, modify_num);
    if (curStatus == "Active" || curStatus == "OK") {
      // if (modify_num > 6) {
      //   backLink = '/loans?filter={"status":"active","curStatus":"OK6"}';
      //   loanStage = "Current with > 6 Resets";
      //   loanBgColor = "#1976d2";
      // } else if (modify_num >= 3 && modify_num <= 6) {
      if (modify_num >= 3) {
        backLink = '/loans?filter={"status":"active","curStatus":"OK36"}';
        loanStage = "Current with > 3 Resets";
        loanBgColor = "#1976d2";
      } else if (modify_num > 0 && modify_num < 3) {
        backLink = '/loans?filter={"status":"active","curStatus":"OK3"}';
        loanStage = "Current with < 3 Resets";
        loanBgColor = "#1976d2";
      } else {
        backLink = defaultActiveBackLink;
        loanStage = "Current with 0 Resets";
        loanBgColor = "#1976d2";
        if (remainingTermFilter == "<12 Months") {
          loanStageStatus = "Maturing in 12 M";
        } else if (remainingTermFilter == "12-24 Months") {
          loanStageStatus = "Maturing in 12-24 M";
        } else if (remainingTermFilter == "24-36 Months") {
          loanStageStatus = "Maturing in 24-36 M";
        } else if (remainingTermFilter == "36-48 Months") {
          loanStageStatus = "Maturing in 36-48 M";
        } else if (remainingTermFilter == "48-60 Months") {
          loanStageStatus = "Maturing in 48-60 M";
        } else if (remainingTermFilter == ">60 Months") {
          loanStageStatus = "Maturing in >60 M";
        }

        console.log("remainingTermFilter", remainingTermFilter);
      }
    } else if (curStatus == "30D" || curStatus == "60D" || curStatus == "90D") {
      backLink = `/loans?filter={"status":"active","curStatus":"large30D"}`;
      loanStage = "Delinquent > 30D";
      loanBgColor = "#ed6c02";
    } else if (curStatus == "Late") {
      backLink = `/loans?filter={"status":"active","curStatus":"Late"}`;
      loanStage = "Delinquent < 30D";
      loanBgColor = "#ed6c02";
    }

    if (
      smartach === true &&
      maturityDate &&
      new Date(maturityDate) <=
        new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
    ) {
      backLink = `/loans?filter={"status":"active","curStatus":"delinquentPastMaturity"}`;
      loanStage = "Delinquent Past Maturity";
      loanStageStatus = "";
      loanBgColor = "#d32f2f";
    }

    if (transferFatalErrorNumber >= 1) {
      backLink = `/loans?filter={"status":"active","curStatus":"Funding Source Removed"}`;
      loanStage = "Attention Required";
      loanStageStatus = "Funding Source Removed";
      loanBgColor = "#d32f2f";
    }
    if (transferFailedNumber >= 2) {
      backLink = `/loans?filter={"status":"active","curStatus":"Transfer Failed"}`;
      loanStage = "Attention Required";
      loanStageStatus = "Transfer Failed";
      loanBgColor = "#d32f2f";
    }
    if (insufficientBalanceCheckNumber >= 2) {
      backLink = `/loans?filter={"status":"active","curStatus":"Insufficient Balance"}`;
      loanStage = "Attention Required";
      loanStageStatus = "Insufficient Balance";
      loanBgColor = "#d32f2f";
    }

    // }
  }
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        mb: 1,
        fontWeight: "bold",
        backgroundColor: loanBgColor || "#fff3cd",
        color: loanBgColor == "#00000014" ? "black" : "white",
        p: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "60px",
      }}
    >
      {loanStage}
      {/* <br /> curStatus : {curStatus}
      <br /> modify_num : {modify_num}
      <br /> remainingTermFilter : {remainingTermFilter}
      <br /> loanStageStatus : {loanStageStatus} */}
      {loanStageStatus ? (
        <>
          <br /> {loanStageStatus}
        </>
      ) : null}
    </Typography>
  );
};

export default LoanStageStatus;
